export const getIsServicesSaving = (state) => state.servicesLoading;
